(ns fablo-offers.common.lib.hooks
  (:require
   ["react-i18next" :as i18n]
   ["react" :as react]
   [rumext.alpha :as mf]))

(defn use-translation
  ([] (use-translation nil))
  ([ns]
   (let [usei18n (if ns
                   (i18n/useTranslation (if (keyword? ns)
                                          (name ns)
                                          ns))
                   (i18n/useTranslation))
         t (aget usei18n "t")
         i18n (aget usei18n "i18n")]
     {:t (fn [k & [opts]]
           (cond
             (nil? k) nil
             (keyword? k) (t (if-let [ns (namespace k)]
                               (str ns ":" (name k))
                               (name k))
                             (clj->js opts))
             (map? k) (get k (keyword (.-language i18n)) (first (vals k)))
             (and (string? k) (re-matches #"\d\d:\d\d" k)) k ;; workaound for hours with ":"
             :else (t k (clj->js opts))))
      :i18n i18n})))

(defn use-t
  ([] (use-t nil))
  ([ns] (:t (use-translation ns))))

(defn use-debounced-callback
  "Returns a debounced version of the callback that delays invoking until after delay-ms have elapsed since the last time it was invoked."
  [callback delay-ms]
  (let [timeout-ref (mf/use-ref nil)]
    (mf/use-callback
     (mf/deps [callback delay-ms])
     (fn [& args]
       ;; Clear existing timeout
       (when-let [timeout (mf/ref-val timeout-ref)]
         (js/clearTimeout timeout))
       ;; Set new timeout
       (mf/set-ref-val!
        timeout-ref
        (js/setTimeout
         #(apply callback args)
         delay-ms))))))
